
import { defineComponent, PropType } from 'vue';
import { color, HexColor } from '@/domain/models/Color';

export default defineComponent({
	name: 'Chip',

	props: {
		color: {
			type: String as PropType<HexColor>,
			required: true,
		},
	},

	setup(props) {
		const chipColor = color(props.color);

		return {
			chipStyle: {
				backgroundColor: chipColor.value,
				color: chipColor.contrast,
			},
		};
	},
});
